import { CompanyResource } from "../barcodeCompanies/get";
import { StockAdjustmentDetailResource, StockAdjustmentResource } from "./get";

export interface EditStockAdjustmentRequest extends StockAdjustmentResource {
  details: EditStockAdjustmentDetail[];
}

export interface EditStockAdjustmentResponse {
  id: number;
}

export class EditStockAdjustmentDetail implements StockAdjustmentDetailResource {
  id: number | null;
  stockAdjustmentId: number | null;
  companyId: number;
  company: CompanyResource | null;
  manufacturerCode: string | null;
  itemType: string | null;
  itemScan: string | null;
  bulkScan: string | null;
  modelNumber: string | null;
  serialNumber: string | null;
  poNumber: string | null;
  itemDescription: string | null;
  quantity: number;
  adjustedDate: Date | null;
  isDamaged: boolean | null;
  damageCode: string | null;
  isBulkItem: boolean;
  inventoryItemId: number | null;
  bulkItemId: number | null;
  sku: string | null;
  soNumber: string | null;
  warehouseLocationId: number | null;
  warehouseLocationCode: string | null;
  selected: boolean;

  constructor(resource : StockAdjustmentDetailResource){
    if(resource){
      this.id = resource.id;
      this.stockAdjustmentId = resource.stockAdjustmentId;
      this.companyId = resource.companyId;
      this.company = resource.company;
      this.manufacturerCode = resource.manufacturerCode;
      this.itemType = resource.itemType;
      this.itemScan = resource.itemScan;
      this.bulkScan = resource.bulkScan;
      this.modelNumber = resource.modelNumber;
      this.serialNumber = resource.serialNumber;
      this.poNumber = resource.poNumber;
      this.itemDescription = resource.itemDescription;
      this.quantity = resource.quantity;
      this.adjustedDate = resource.adjustedDate;
      this.isDamaged = resource.isDamaged;
      this.damageCode = resource.damageCode;
      this.isBulkItem = resource.isBulkItem;
      this.inventoryItemId = resource.inventoryItemId;
      this.bulkItemId = resource.bulkItemId;
      this.sku = resource.sku;
      this.soNumber = resource.soNumber;
      this.warehouseLocationId = resource.warehouseLocationId;
      this.warehouseLocationCode = resource.warehouseLocationCode;
    }
    else{
      this.isBulkItem = true;
    }
  }
}

export class EditStockAdjustment implements EditStockAdjustmentRequest {
  id: number | null;
  facilityCode: string;
  createdByUserId: string | null;
  createdByUsername: string | null;
  createdDate: Date | null;
  wasApplied: boolean;
  appliedByUserId: string | null;
  appliedByUsername: string | null;
  appliedDate: Date | null;
  comments: string | null;
  details: EditStockAdjustmentDetail[];

  public isNew(){
    return this.id == null;
  }

  public GetRequest() : EditStockAdjustmentRequest{
    return this;
  }

  constructor(resource : StockAdjustmentResource, details : Array<StockAdjustmentDetailResource>){
    if(resource)
    {
      this.id = resource.id;
      this.facilityCode = resource.facilityCode;
      this.createdByUserId = resource.createdByUserId;
      this.createdByUsername = resource.createdByUsername;
      this.createdDate = resource.createdDate;
      this.wasApplied = resource.wasApplied;
      this.appliedByUserId = resource.appliedByUserId;
      this.appliedByUsername = resource.appliedByUsername;
      this.appliedDate = resource.appliedDate;
      this.comments = resource.comments;
      if(details)
        this.details = details.map(x => new EditStockAdjustmentDetail(x));
      else
        this.details = [];
    }
    else {
      this.details = [];
    }
  }
}
  